module.exports = ".hidden{\r\n    display: none;\r\n}\r\n/* .maskbox{\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n} */"